import { render, staticRenderFns } from "./EducationDetails.vue?vue&type=template&id=c5901688&scoped=true"
import script from "./EducationDetails.vue?vue&type=script&lang=js"
export * from "./EducationDetails.vue?vue&type=script&lang=js"
import style0 from "./EducationDetails.vue?vue&type=style&index=0&id=c5901688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5901688",
  null
  
)

export default component.exports